
import { Routes, Route } from "react-router-dom";

// Auth & Shared Components
import { Toaster } from "sonner";
import LoginDialog from "@/modules/auth/components/loginDialog";
import ResetPasswordPage from "@/modules/auth/components/ResetPasswordPage";

import ProtectedRoute from "../shared/ProtectedRoutes/protectedRoute";
import Layout from "../shared/components/Layout";
import GlobalLoader from "@/shared/components/Loader/GlobalLoader";

// Public Pages
import CareerPage from "../modules/Career/CareerPage";
import JobDetailPage from "../modules/jobs/components/JobDetailPage";

// HR Pages
import HRDashboard from "../modules/hrPortal/components/HRDashboard";
import HRMyTeamPage from "../modules/hrPortal/components/HRMyTeamPage";
import CandidateDetailsPage from "@/modules/hrPortal/components/CandidateDetailsPage";
import HRJobApplicantsPage from "../modules/hrPortal/components/HRJobApplicantsPage";
import HRLayout from "../modules/hrPortal/components/HRDashboard/HRLayout";

// Candidate Pages
import CandidateLayout from "@/modules/candidate/components/CandidateLayout";
import CandidateDashboard from "@/modules/candidate/components/dashboard/CandidateDashboard";
import Applications from "@/modules/candidate/components/applications/Applications";
import Documents from "@/modules/candidate/components/Documents";
import Notifications from "@/modules/candidate/components/Notifications";
import Settings from "@/modules/candidate/components/Settings";
import ApplicationDetails from "@/modules/candidate/components/applications/application-details";
import Profile from "@/modules/candidate/components/profile/Profile";

// Admin Pages
import AdminLayout from "@/modules/adminPortal/Components/admin/AdminLayout";
import AdminDashboard from "@/modules/adminPortal/Components/admin/AdminDashboard";
import JobsAdminPage from "@/modules/adminPortal/Components/admin/JobsAdminPage";
import VoiceAgentPage from "@/modules/adminPortal/Components/admin/VoiceAgentPage";
import MasterDatabasePage from "@/modules/adminPortal/Components/admin/MasterDatabasePage";
import TeamAdminPage from "@/modules/adminPortal/Components/admin/Team";

export default function App() {
  return (
    <>
      <GlobalLoader />
      <LoginDialog />

      <Toaster
        position="top-right"
        duration={3500}
        expand={false}
        visibleToasts={3}
      />

      <Routes>
        <Route element={<Layout />}>
          {/* PUBLIC ROUTES */}

          <Route path="/" element={<CareerPage />} />

          <Route path="/jobs/:id" element={<JobDetailPage />} />

          <Route
            path="/reset-password"
            element={<ResetPasswordPage />}
          />

          {/* HR ROUTES */}

          <Route
            path="/hr"
            element={
              <ProtectedRoute requiredRole="hr">
                <HRLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<HRDashboard />} />

            <Route path="candidates" element={<HRDashboard />} />

            <Route path="voice-calls" element={<HRDashboard />} />

            <Route path="jobs" element={<HRDashboard />} />

            <Route path="resume-database" element={<HRDashboard />} />

            {/* Imported/manual Master Database record */}
            <Route
              path="candidates/master-db/:recordId"
              element={<CandidateDetailsPage />}
            />

            {/* Existing portal application details */}
            <Route
              path="candidates/:id"
              element={<CandidateDetailsPage />}
            />

            <Route
              path="jobs/:jobId/applicants"
              element={<HRJobApplicantsPage />}
            />

            <Route
              path="my-team"
              element={
                <ProtectedRoute requiredRole="hr" exactRole>
                  <HRMyTeamPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* CANDIDATE ROUTES */}

          <Route
            path="/candidate"
            element={
              <ProtectedRoute requiredRole="candidate">
                <CandidateLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<CandidateDashboard />} />

            <Route path="applications" element={<Applications />} />

            <Route
              path="application-details/:id"
              element={<ApplicationDetails />}
            />

            <Route path="documents" element={<Documents />} />

            <Route path="notifications" element={<Notifications />} />

            <Route path="settings" element={<Settings />} />

            <Route path="profile" element={<Profile />} />
          </Route>

          {/* ADMIN ROUTES */}

          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />

            <Route path="jobs" element={<JobsAdminPage />} />

            <Route path="voice-agent" element={<VoiceAgentPage />} />

            <Route path="master-db" element={<MasterDatabasePage />} />

            {/* Imported/manual Master Database record */}
            <Route
              path="master-db/candidates/master-db/:recordId"
              element={<CandidateDetailsPage />}
            />

            {/* Existing portal application details */}
            <Route
              path="master-db/candidates/:id"
              element={<CandidateDetailsPage />}
            />

            <Route path="team" element={<TeamAdminPage />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}
